<template>
  <div class="has-background-white panier-component columns ml-0 mt-15" v-if="reseau">
    <div class="column is-narrow ml-40 mr-12">
      <img v-if="reseau.urlPhoto"
          class="image tailleImage"
          :src="reseau.urlPhoto">
      <img v-else class="image tailleImage" src="@/assets/default-placeholder.png"/>
      <p class="has-text-weight-bold has-text-dark is-size-6 champReseau">
        Réseau : <span>{{reseau.libelle}}</span>
      </p>
      <p>Nb de faces :
        {{reseau.extensionOpportunite.facesPrevues}}
      </p>
      <p class="champSemaine has-text-weight-bold has-text-default">
        {{
          reseau.extensionOpportunite.newPeriode ?
          reseau.extensionOpportunite.newPeriode :
          chaineSemaineReservation
        }}
      </p>
      <b-modal v-model="isComponentDetailReseauxTempo"
              has-modal-card
              class="modal">
            <info-window-reseaux-tempo :reseau ="reseau"/>
      </b-modal>
      <a class="plusInfo" @click="isComponentDetailReseauxTempo = !isComponentDetailReseauxTempo">
        Plus d'informations sur le réseau
      </a>
    </div>
    <div class="column columns">
      <div class="column is-paddingless is-one-quarter">
        <div class="column is-12 p-5px">
          <label class="subtitle">Tarif brut HT</label>
          <b-field>
            <input-currency
              v-model="reseau.extensionOpportunite.tarifHT"
              isNumber="true"
              :disabled="disabled"
              @blur="tarifHTChange"/>
          </b-field>
        </div>
        <div class="column is-12 p-5px">
          <div class="control">
            <label class="subtitle">{{getLibelleTarifPose}}</label>
            <input-currency
              v-model="reseau.extensionOpportunite.tarifDePose"
              isNumber="true"
              :disabled="disabled || sopaDisabled">
            </input-currency>
          </div>
        </div>
        <div class="column is-12 p-5px">
          <div class="control">
            <label class="subtitle">Taxes municipales / TLPE</label>
            <input-currency
              v-model="reseau.extensionOpportunite.taxeMunicipale"
              :disabled="disabled || sopaDisabled">
            </input-currency>
          </div>
          Montant TLPE pour la durée de location
        </div>
      </div>
      <div class="column is-paddingless ">
        <div class="column is-12 columns is-marginless p-5px">
          <div class="column is-paddingless">
            <b-field label="Remise" custom-class="mb-0 label-color" expanded>
              <b-field>
                <input-currency
                  v-model="reseau.extensionOpportunite.remise"
                  isNumber="true"
                  :disabled="disabled"
                  @blur="remiseChange"/>
                <b-select
                  v-model="reseau.extensionOpportunite.typeDeRemise"
                  placeholder="0"
                  :disabled="disabled">
                  <option :value="0">%-</option>
                  <option :value="1">€</option>
                </b-select>
              </b-field>
            </b-field>
          </div>
          <div class="column is-paddingless is-5 ml-2">
            <b-field label="Tarif Net HT" custom-class="mb-0 label-color" expanded>
              <input-currency
                v-model="reseau.extensionOpportunite.tarifNet"
                isNumber="true"
                :disabled="disabled"
                @blur="tarifNetChange">
              </input-currency>
            </b-field>
          </div>
        </div>
        <div class="column is-12 p-5px">
          <div class="control">
            <label class="subtitle">Tarif d'impression HT</label>
            <input-currency
              v-model="reseau.extensionOpportunite.tarifImpression"
              isNumber="true"
              :disabled="disabled">
            </input-currency>
          </div>
        </div>
        <div class="column is-12 p-5px">
          <b-field grouped class="mt-5px">
            <b-field label="Etat souhaité" custom-class="mb-0 label-color" expanded>
              <b-select
                v-model="reseau.extensionOpportunite.demande"
                expanded
                :disabled="disabled">
                <option value="0">Option</option>
                <option value="1" v-if="!isClientTotalementBloque">Bloqué</option>
                <option
                  value="2"
                  v-if="isAffixe2 && (isModif || disabled)">
                  Sans suite
                </option>
                <option
                  value="3"
                  v-if="isAffixe2 && (isModif || disabled)">
                  Annulation
                </option>
              </b-select>
            </b-field>
            <b-field :label="isModif && $route.name !== 'detailopportunite'
              ? 'Ancien état obtenu' : 'Etat obtenu'"
              custom-class="mb-0 label-color" expanded>
              <div style="display: flex; margin-top: 10px">
                <b-tag :type="colorEtat(reseau.extensionOpportunite.etatObtenu)"
                  class="mr-2px autoheight"
                  v-if="reseau.extensionOpportunite.etatObtenu"></b-tag>
                <span class="has-text-weight-bold">
                  {{reseau.extensionOpportunite.etatObtenu}} </span>
              </div>
            </b-field>
          </b-field>
        </div>
      </div>
      <div class="column is-paddingless is-one-third">
        <div class="column columns mb-0 pb-0">
          <div class="column p-5px" :class="isYieldActivated ? 'is-5' : 'is-6'">
            <b-field label="Nb faces souhaitées" custom-class="mb-0 label-color">
              <input
                class="input"
                type="number"
                v-model="reseau.extensionOpportunite.facesSouhaitees"
                :disabled="disabled"
                @focus="facesSouhaiteesFocus"
                @blur="facesSouhaiteesChange"/>
            </b-field>
          </div>
          <div class="column p-5px" :class="isYieldActivated ? 'is-4' : 'is-6'">
            <b-field label="Prix Net face" custom-class="mb-0 label-color">
              <input-currency
                  v-model="tarifNetFace"
                  isNumber="true"
                  :disabled="disabled"
                  @blur="tarifNetFaceChange">
                </input-currency>
            </b-field>
          </div>
          <div class="column is-3 p-5px" v-if="isYieldActivated">
            <b-field label="Objectif" custom-class="mb-0 label-color">
              <input-currency
                  v-model="reseau.objectif"
                  :class="{
                    'objectif-rouge': !isObjectifAtteint && reseau.objectif,
                    'objectif-vert': isObjectifAtteint && reseau.objectif,
                  }"
                  :disabled="true"
                  :title="reseau.objectif">
                </input-currency>
            </b-field>
          </div>
        </div>
        <div class="column is-12 p-5px">
          <b-field label="Commentaire" custom-class="mb-0 label-color">
            <b-input
              type="textarea"
              v-model="reseau.extensionOpportunite.commentaire"
              :disabled="disabled"/>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column columns is-multiline is-3">
      <div class="column is-narrow p-5px">
        <article class="media media-align-center">
          <div class="media-left mt-20">
            <button
              class="button"
              :class="{
                'is-primary': !reseau.listeFaces.find((el) => el.selected ),
                'is-success': reseau.listeFaces.find((el) => el.selected )
              }"
              @click="openListeFaces(reseau)"
              :disabled="disabled">
                <b-icon icon="playlist-plus"></b-icon>
            </button>
          </div>
          <div class="media-content is-paddingless">
            <div
              v-if="reseau.listeFaces.filter(el=> el.selected).length > 0"
              class="content has-text-weight-semibold">
              {{ reseau.listeFaces.filter(el=> el.selected).length }}
              faces sélectionnée(s)
            </div>
            <div v-else class="content has-text-weight-semibold">
              Listes des faces
            </div>
          </div>
        </article>
      </div>
      <div class="column p-5px">
        <div class="is-flex flex-align-center-justify-end">
          <p class="has-text-weight-bold is-size-6 has-text-black mr-12">
            {{reseau.prixTotal}} €
          </p>
          <a @click="suppressionPanneau">
            <b-icon icon="delete-forever" type="is-danger"/>
          </a>
        </div>
      </div>
      <div class="column is-12 p-5px" v-if="afficheBtnDupliquer.length > 0">
        <b-button v-if="afficheBtnDupliquer.length > 0"
          type="is-primary"
          icon-right="content-copy"
          :disabled="disabled"
          @click="isComponentOuvrirCopyListeFaces = true"/>
      </div>
      <div class="column is-12 p-5px">
        <article class="media media-align-center">
          <div class="media-left">
            <button
              class="button is-primary"
              @click="ouvrirDiaporama(reseau)"
              :disabled="disabled">
              <b-icon icon="image-multiple"></b-icon>
            </button>
          </div>
          <div class="media-content is-paddingless">
            <div class="content has-text-weight-semibold">
              Diaporama
            </div>
          </div>
        </article>
      </div>
      <div class="column is-11 is-multiline has-background-color-background ml-5px mt-10">
        <span class="mb-0 label-color has-text-weight-bold">Editions</span>
        <div class="column is-12 p-5px">
          <article class="media media-align-center">
            <div class="media-left">
              <button
                class="button"
                :disabled="disabled"
                :class="[reseau.extensionOpportunite.masquerRemiseEdition
                 ? 'is-primary' : 'is-grey']"
                @click.prevent="$refs.checkBoxMasquerRemiseEdition.click()">
                <b-icon
                  icon="percent"
                  :type="reseau.extensionOpportunite.masquerRemiseEdition ? 'is-white' : 'is-grey'">
                </b-icon>
              </button>
            </div>
            <div class="media-content is-paddingless">
              <div class="content has-text-weight-semibold is-inline">
                Afficher la remise sur l’édition
              </div>
              <input
                type="checkbox"
                v-model="reseau.extensionOpportunite.masquerRemiseEdition"
                :disabled="disabled"
                id="checkbox"
                class="is-invisible is-inline"
                ref="checkBoxMasquerRemiseEdition">
            </div>
          </article>
        </div>
        <div class="column is-12 p-5px">
          <article class="media media-align-center">
            <div class="media-left">
              <button
                class="button"
                :disabled="disabled"
                :class="[reseau.extensionOpportunite.masquerFaceEdition ? 'is-primary' : 'is-grey']"
                @click="reseau.extensionOpportunite.masquerFaceEdition =
                  !reseau.extensionOpportunite.masquerFaceEdition">
                <b-icon
                  icon="eye-off"
                  :type="reseau.extensionOpportunite.masquerFaceEdition ? 'is-white' : 'is-grey'"/>
              </button>
            </div>
            <div class="media-content is-paddingless">
              <div class="content has-text-weight-semibold">
                Masquer les faces sur l'édition
              </div>
            </div>
          </article>
        </div>
        <div class="column is-12 p-5px">
          <article class="media media-align-center">
            <div class="media-left">
              <button
                class="button"
                :disabled="disabled"
                :class="reseau.extensionOpportunite.visualiserCarteEdition
                 ? 'is-primary' : 'is-grey'"
                @click.prevent="$refs.checkBoxVisuCartoReseauTempo.click()">
                <b-icon icon="google-maps"/>
              </button>
            </div>
            <div class="media-content is-paddingless">
              <div class="content has-text-weight-semibold">
                Afficher la cartographie
              </div>
            </div>
            <input
              type="checkbox"
              v-model="reseau.extensionOpportunite.visualiserCarteEdition"
              :disabled="disabled"
              id="checkbox"
              class="is-invisible"
              ref="checkBoxVisuCartoReseauTempo">
          </article>
        </div>
      </div>
    </div>
    <b-modal
      v-model="isComponentOuvrirListeFaces"
      has-modal-card
      class="modal modal-liste-faces"
      width="80vw">
      <app-consultation :reseau="reseau" :disabled="disabled"/>
    </b-modal>
    <b-modal
      v-model="isComponentOuvrirCopyListeFaces"
      has-modal-card
      class="modal modal-liste-faces">
      <app-copy-face-reseau
        :reseau="reseau"
        :disabled="disabled"
        @close="isComponentOuvrirCopyListeFaces = false"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/panier-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import inputCurrency from '@/components/general/inputCurrency';
import numberFormat from '@/services/general/numberFormat';
import arrondiResult from '@/services/general/arrondiCalcul';
import gestionErreur from '@/services/general/gestionErreur';
import {
  BLOQUE,
  OPTION,
  INDISPONIBLE,
  VAL_OPTION,
  VAL_BLOQUE,
} from '@/configuration/optionBlocage';
import { BLOCAGE_CLIENT_TOTAL } from '@/configuration/devisConf';
import { getFacesSelectionneesIndispo } from '@/api/reseaux/index';
import getAnneeSemaine, { getDateByJourAnneeSemaine } from '@/services/general/getAnneeSemaine';
import { PARAMETRES_AFFIXE2 } from '@/configuration/paramsAffixe2';
import Consultation from './venteReseauxTempo/consultation/index';
import CopyFaceReseau from './venteReseauxTempo/copyFaceReseau';
import infoWindowReseauxTempo from './venteReseauxTempo/infoWindowReseauxTempo';
import ErreurFaceDisponible from './venteReseauxTempo/ErreurFaceDisponible';

const Panier = createNamespacedHelpers('panier');
const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');
const Modal = createNamespacedHelpers('modal');
const user = createNamespacedHelpers('user');
const Parametrages = createNamespacedHelpers('parametrage');

export default {
  name: 'ventes-reseau-tempo',
  components: {
    inputCurrency,
    infoWindowReseauxTempo,
    appConsultation: Consultation,
    appCopyFaceReseau: CopyFaceReseau,
  },
  props: ['reseau', 'disabled'],
  data() {
    return {
      openPeriod: true,
      newPeriod: '',
      tarifBaseBrut: numberFormat(this.reseau.extensionOpportunite.tarifBaseBrut),
      tarifBaseFaces: numberFormat(this.reseau.extensionOpportunite.tarifBaseFaces),
      tarifBaseTaxes: numberFormat(this.reseau.extensionOpportunite.tarifBaseTaxes),
      tarifBasePose: numberFormat(this.reseau.extensionOpportunite.tarifBasePose),
      dateDebut: getDateByJourAnneeSemaine(
        this.reseau.jourDepart,
        this.reseau.extensionOpportunite.annee,
        this.reseau.extensionOpportunite.semaine),
      // Obligé parce que le back fait jour de départ -1 ...
      dateVisualisation: getDateByJourAnneeSemaine(
        this.reseau.jourDepart + 1,
        this.reseau.extensionOpportunite.annee,
        this.reseau.extensionOpportunite.semaine),
      isComponentOuvrirListeFaces: false,
      showPeriode: true,
      newPeriode: '',
      isComponentDetailReseauxTempo: false,
      isComponentOuvrirCopyListeFaces: false,
      tarifNetFace: this.getTarifNetFaceByTarifNet(
        this.reseau.extensionOpportunite.tarifNet),
      remise: this.reseau.extensionOpportunite.remise,
      typingTimer: null,
      doneTypingInterval: 1000,
      tarifParFace: {
        tarifHT: 0,
        tarifNet: 0,
        tarifDePose: 0,
        taxeMunicipale: 0,
      },
    };
  },
  watch: {
    'reseau.extensionOpportunite.demande': {
      handler(val, oldVal) {
        this.actionChangeEtatSouhaite(val, oldVal);
      },
    },
  },
  computed: {
    ...VenteReseauxTempo.mapGetters({
      reseauxWithFilter: 'reseauxWithFilter',
    }),
    ...user.mapGetters({
      isAffichageFaceEditionDefault: 'isAffichageFaceEditionDefault',
      site: 'site',
    }),
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesReseauSelect: 'facesSelectDiapo',
    }),
    ...Panier.mapGetters({
      reseauxTempoPanier: 'reseauxTempoPanier',
      getClientPanier: 'clientPanier',
      isModif: 'isModif',
    }),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
      isYieldActivated: 'isActivationYield',
    }),
    facesReseauSelectDiapo: {
      get() {
        return this.getFacesReseauSelect;
      },
      set(value) {
        this.setFacesReseauSelect(value);
      },
    },
    getLibelleTarifPose() {
      if (this.site === 'sopa') {
        return 'FPEA HT';
      }
      return 'Tarif de pose HT';
    },
    sopaDisabled() {
      if (this.site === 'sopa') {
        return true;
      }
      return false;
    },
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
    chaineSemaineReservation() {
      return `Semaine ${this.reseau.extensionOpportunite.semaine}
              du ${this.dateDebut.format('DD MMMM')}
              au  ${this.dateDebut.clone().add(7 * this.reseau.dureeConservation, 'days').add(-1, 'days').format('DD MMMM YYYY')}`;
    },
    afficheBtnDupliquer() {
      return this.reseauxTempoPanier
        .filter(reseau => reseau.num === this.reseau.num
        && !(reseau.extensionOpportunite.semaine === this.reseau.extensionOpportunite.semaine
        && reseau.extensionOpportunite.annee === this.reseau.extensionOpportunite.annee));
    },
    valeurRemise() {
      if (this.reseau.extensionOpportunite.typeDeRemise === 0) {
        return (this.reseau.extensionOpportunite.tarifHT
          * this.reseau.extensionOpportunite.remise) / 100;
      }
      return this.reseau.extensionOpportunite.remise;
    },
    isObjectifAtteint() {
      return this.tarifNetFace >= this.reseau.objectif;
    },
    isClientTotalementBloque() {
      return this.isAffixe2 && this.getClientPanier &&
      this.getClientPanier.blocageLevel === BLOCAGE_CLIENT_TOTAL;
    },
  },
  methods: {
    ...Panier.mapMutations({
      setRemoveProduit: types.REMOVE_PRODUIT_TYPE_RESEAU_TEMPO,
    }),
    ...Panier.mapActions({
      actionsGetFacesDeReseau: 'getFacesDeReseau',
    }),
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
      setFacesReseauSelect: typesModal.SET_FACES_SELECT_DIAPO,
    }),
    ...Parametrages.mapActions({
      loadParamAffixe2: 'loadParamAffixe2',
    }),
    suppressionPanneau() {
      this.setRemoveProduit(this.reseau);
    },
    actionkeyUp(action) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(action, this.doneTypingInterval);
    },
    actionkeyDown() {
      clearTimeout(this.typingTimer);
    },
    tarifHTChange() {
      if (this.reseau.extensionOpportunite.tarifHT) {
        this.reseau.extensionOpportunite.tarifNet =
          this.reseau.extensionOpportunite.tarifHT - this.valeurRemise;
        this.tarifNetFace = this.reseau.extensionOpportunite.tarifNet
          / this.reseau.extensionOpportunite.facesSouhaitees;
      }
    },
    remiseChange() {
      if (this.reseau.extensionOpportunite.tarifHT) {
        this.reseau.extensionOpportunite.tarifNet =
          this.reseau.extensionOpportunite.tarifHT - this.valeurRemise;
      }
      this.tarifNetFace = this.reseau.extensionOpportunite.tarifNet
        / this.reseau.extensionOpportunite.facesSouhaitees;
    },
    tarifNetChange() {
      if (this.reseau.extensionOpportunite.tarifHT) {
        const valeurRemise = this.reseau.extensionOpportunite.tarifHT
          - this.reseau.extensionOpportunite.tarifNet;
        if (this.reseau.extensionOpportunite.typeDeRemise === 0) {
          this.reseau.extensionOpportunite.remise = (valeurRemise * 100)
            / this.reseau.extensionOpportunite.tarifHT;
        } else this.reseau.extensionOpportunite.remise = valeurRemise;
      }
      this.tarifNetFace = this.reseau.extensionOpportunite.tarifNet
        / this.reseau.extensionOpportunite.facesSouhaitees;
    },
    facesSouhaiteesFocus() {
      const tarifHT = this.reseau.extensionOpportunite.tarifHT
        ? this.reseau.extensionOpportunite.tarifHT : 0;
      const tarifNet = this.reseau.extensionOpportunite.tarifNet
        ? this.reseau.extensionOpportunite.tarifNet : 0;
      const tarifDePose = this.reseau.extensionOpportunite.tarifDePose
        ? this.reseau.extensionOpportunite.tarifDePose : 0;
      const taxeMunicipale = this.reseau.extensionOpportunite.taxeMunicipale
        ? this.reseau.extensionOpportunite.taxeMunicipale : 0;
      if (this.reseau.extensionOpportunite.facesSouhaitees) {
        this.tarifParFace.tarifHT = tarifHT / this.reseau.extensionOpportunite.facesSouhaitees;
        this.tarifParFace.tarifNet = tarifNet / this.reseau.extensionOpportunite.facesSouhaitees;
        this.tarifParFace.tarifDePose = tarifDePose
          / this.reseau.extensionOpportunite.facesSouhaitees;
        this.tarifParFace.taxeMunicipale = taxeMunicipale
          / this.reseau.extensionOpportunite.facesSouhaitees;
      }
    },
    facesSouhaiteesChange() {
      this.reseau.extensionOpportunite.tarifHT = this.tarifParFace.tarifHT
        * this.reseau.extensionOpportunite.facesSouhaitees;
      this.reseau.extensionOpportunite.tarifNet = this.tarifParFace.tarifNet
        * this.reseau.extensionOpportunite.facesSouhaitees;
      this.reseau.extensionOpportunite.tarifDePose =
        this.tarifParFace.tarifDePose * this.reseau.extensionOpportunite.facesSouhaitees;
      this.reseau.extensionOpportunite.taxeMunicipale =
        this.tarifParFace.taxeMunicipale * this.reseau.extensionOpportunite.facesSouhaitees;
    },
    tarifNetFaceChange() {
      this.reseau.extensionOpportunite.tarifNet = this.tarifNetFace
        * this.reseau.extensionOpportunite.facesSouhaitees;
      if (this.reseau.extensionOpportunite.tarifHT) {
        const valeurRemise = this.reseau.extensionOpportunite.tarifHT
          - this.reseau.extensionOpportunite.tarifNet;
        if (this.reseau.extensionOpportunite.typeDeRemise === 0) {
          this.reseau.extensionOpportunite.remise = (valeurRemise * 100)
            / this.reseau.extensionOpportunite.tarifHT;
        } else this.reseau.extensionOpportunite.remise = valeurRemise;
      }
    },
    async openListeFaces(reseau) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await this.actionsGetFacesDeReseau({ reseau: reseau, dateDebut: this.dateVisualisation.format('YYYYMMDD') });
        loadingComponent.close();
        this.isComponentOuvrirListeFaces = true;
      } catch (e) {
        loadingComponent.close();
        gestionErreur(`Erreur lors de l'ouverture de la liste des faces du reseau n°${reseau.num}`, e);
        throw e;
      }
    },
    async ouvrirDiaporama(reseau) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await this.actionsGetFacesDeReseau({ reseau: reseau, dateDebut: this.dateDebut.format('YYYYMMDD') });
        reseau.listeFaces.forEach((el) => {
          el.libelleReseau = reseau.libelle;
        });
        this.facesReseauSelectDiapo = reseau.listeFaces;
        this.facesReseauSelectDiapo.forEach((el) => {
          if (el.urlPhoto) el.urlPhoto = (el.urlPhoto).replace('http://client.affixe-logiciel.fr', 'https://secure.affixe-logiciel.fr');
        });
        loadingComponent.close();
        this.isComponentDiaporama = true;
      } catch (e) {
        loadingComponent.close();
        gestionErreur(`Erreur lors de l'ouverture du diaporama des faces du reseau n°${reseau.num}`, e);
        throw e;
      }
    },
    setNewPeriode() {
      this.newPeriode = this.reseau.extensionOpportunite.newPeriode ?
        this.reseau.extensionOpportunite.newPeriode :
        this.chaineSemaineReservation;
      this.showPeriode = false;
    },
    validNewPeriode() {
      this.reseau.extensionOpportunite.newPeriode = this.newPeriode;
      this.showPeriode = true;
    },
    colorEtat(etat) {
      let color = 'is-white';
      if (etat === BLOQUE) color = 'is-bloque';
      if (etat === OPTION) color = 'is-option';
      if (etat === INDISPONIBLE) color = 'is-bloque';
      return color;
    },
    getTarifNetFaceByTarifNet(value) {
      return arrondiResult(value / this.reseau.extensionOpportunite.facesSouhaitees);
    },
    async actionChangeEtatSouhaite(value, oldValue) {
      const facesSelectionnees = this.reseau.listeFaces.filter(el => el.selected);
      if (oldValue === VAL_OPTION
          && value === VAL_BLOQUE
          && facesSelectionnees.length) {
        const loadingComponent = this.$buefy.loading.open({ container: this.$el });
        const facesIds = facesSelectionnees.map(el => el.idProduit);
        const res = (await getFacesSelectionneesIndispo(
          facesIds,
          getAnneeSemaine(
            this.reseau.extensionOpportunite.annee,
            this.reseau.extensionOpportunite.semaine,
          ),
        )).data;
        loadingComponent.close();
        if (res.length) {
          const facesIndisponible = facesSelectionnees
            .filter(face => res
              .map(item => item.produitId)
              .includes(face.idProduit));
          facesIndisponible.forEach(item => {
            const index = this.reseau.listeFaces
              .findIndex(face => face.idProduit === item.idProduit);
            if (index !== -1) {
              this.reseau.listeFaces[index].selected = false;
            }
          });
          this.$buefy.modal.open({
            parent: this,
            component: ErreurFaceDisponible,
            hasModalCard: true,
            props: {
              faces: facesIndisponible,
            },
          });
        }
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open({ container: this.$el });
    try {
      await this.loadParamAffixe2(PARAMETRES_AFFIXE2.activationYield.key);

      this.reseau.extensionOpportunite.newPeriode = this.chaineSemaineReservation;
      if (this.reseau.extensionOpportunite.masquerFaceEdition === null) {
        this.reseau.extensionOpportunite.masquerFaceEdition = !this.isAffichageFaceEditionDefault;
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

  .information {
    margin-bottom: 12px;
  }

  .inputReseauxTempo {
    padding-top:0;
    padding-bottom:11px;
    margin-top:-10px;
  }

  .semaine {
    margin-top: 5px;
    font-weight: bold;
    padding-bottom: 0px;
  }

  .elementPanierTempo {
    margin-left: 0px;
  }

  .bouton-vente-reseau-tempo {
    padding-top: 22px
  }
  .periode {
  display: inline-block;
  height: 25px;
  width: 25px;

  border-radius: 190px;
  background: #3598DC;
  text-align: center;

  text-decoration: none;
  color: white;
}
.periodeIcon {
  margin-top: 4px;
  line-height: 100px;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
}
.inputPeriod{
  margin-top: 5px;
}
.inputPeriod a{
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/venteReseauxTempo.vue